import { render, staticRenderFns } from "./ModalRegisterEquipment.vue?vue&type=template&id=16b80277&"
import script from "./ModalRegisterEquipment.vue?vue&type=script&lang=ts&"
export * from "./ModalRegisterEquipment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports